import {Lesson} from "./lesson";
import {Slider} from "./slider";

export enum CourseType {
    Playlist = 'playlist',
    Default = 'default'
}

export interface Course {
    ID: number,
    image: string,
    lessons: Array<Lesson>,
    name: string,
    progress:number,
    url: string,
    module: string,
    slider: Array<Slider>,
    allow_text_lesson_as_default: boolean,
    cover_video:string,
    hasCpBanner:boolean,
    course_type:CourseType,
    collapsable_accordions:boolean
}


export interface ApiCoursesResponse {
    code: string;
    message: string;
    data: {
        status: number;
        filters: Filter[];
        sections: Section[];
    };
}

export interface CoursesData {
    status: number;
    filters: Filter[];
    sections: Section[];
}

export interface FilterData {
    filterType: string;
    data: FilterObj[];
}
export interface FilterObj {
    title: string;
    value: number;
    category: string;
}

export interface Filter {
    title: string;
    filters: { [key: string]: string };
    slug: string;
}

export interface Section {
    name: string;
    things: Thing[];
}

export interface Thing {
    ID: number;
    name: string;
    has_access: boolean;
    desc: string;
    image: string;
    url: string;
    drill_redirect_url:string,
    progress: number;
    filters: string[];
    is_first: boolean;
    is_last: boolean;
    hasCpPopup: boolean;
    hasCpBanner:boolean;
    cover_video:string;
    oneClickUrl:string;
    is_sc_member?: boolean;
}
